import React from 'react'
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"

import ButtonPrimary from 'components/ButtonPrimary'

import styles from './styles.module.scss'

const AlertModal = props => {
  if (props.isOn) {
    let classes = `${styles.mask} ${styles.mask__alert}`
    if (props.className) {
      classes = `${classes} ${props.className}`
    }
    return (
      <div className={classes}>
        <div className={styles.mask__container}>
          {props.title && <h3>{props.title}</h3>}
          {props.text && <p>{props.text}</p>}
          <div className={styles.mask__actions}>
            <ButtonPrimary color="navy" icon={faCheckCircle} onClick={props.onClose}>{props.confirmText || 'Close'}</ButtonPrimary>
          </div>
        </div>
      </div>
    )
  }
  return null
}

export default AlertModal